module.exports = __webpack_public_path__ + "img/icon1.5f1af9fa.png";